"use strict";
class ComponentTooltip extends HTMLElement {
    constructor() {
        super();
        if (window.innerWidth < 1200)
            return;
        this.parentElement?.addEventListener('mousemove', (e) => {
            this.style.top = `${e.clientY + 20}px`;
            this.style.left = `${e.clientX + 20}px`;
        });
    }
}
customElements.define('tooltip-component', ComponentTooltip);
